import { ChangeEvent, FC } from 'react'
import clsx from 'clsx'

import useIOSOrientation from '../translation-hooks/useIOSOrientation'

import { imgPath } from '../../data'

import styles from './player-controls.module.scss'

interface IPlayerControls {
  isFullScreen: boolean
  isHideControls: any
  toggleFullScreen: () => void
  isMuted: boolean
  toggleMute: () => void
  setVolume: (val: number) => void
  isNotTransparent?: boolean
}

const PlayerControls: FC<IPlayerControls> = ({
  isHideControls,
  isFullScreen,
  toggleFullScreen,
  isMuted,
  toggleMute,
  setVolume,
  isNotTransparent,
}) => {
  const isIOS = useIOSOrientation(isFullScreen)

  const changeVolume = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    setVolume(Number(value))
  }

  return (
    <div
      className={clsx(styles.controlsWrapper, {
        [styles.notTransparentWrapper]: isNotTransparent,
      })}
    >
      <div
        className={clsx(styles.controls, {
          [styles.controlsFullscreen]: isFullScreen,
          [styles.hideControls]: isHideControls,
          [styles.notTransparentControls]: isNotTransparent,
        })}
      >
        <div className={styles.soundWrapper}>
          <button onClick={toggleMute} className={styles.button}>
            <img
              src={isMuted ? imgPath.mute : imgPath.volume}
              className={styles.image}
              alt="включить звук"
              decoding="async"
              loading="lazy"
            />
          </button>
          {!isIOS && (
            <input
              className={clsx(styles.inputRange, {
                [styles.hideOnIosRangeInput]: isIOS,
                [styles.hideWithoutSoundRangeInput]: isMuted,
              })}
              type="range"
              name="volume"
              min="0"
              max="100"
              defaultValue="100"
              onChange={changeVolume}
            ></input>
          )}
        </div>
        <button onClick={toggleFullScreen} className={styles.button}>
          <img
            src={isFullScreen ? imgPath.exitfullscreen : imgPath.fullscreen}
            className={styles.image}
            alt="включить полный экран"
            decoding="async"
            loading="lazy"
          />
        </button>
      </div>
    </div>
  )
}

export default PlayerControls
